// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ImageCommentPin.test.tsx
import { ClockCounterClockwise, X } from "@phosphor-icons/react";
import cx from "classnames";

import { type RejectedPinKind } from "./rejectedPinLabelContext";

/**
 * The small mark on a grayed pin: a cross for a finding rejected in this
 * review, a history arrow on a dashed ring for one rejected in an earlier
 * review, so the two read apart on the artwork as their cards do.
 *
 * Decorative: the pin button carries the accessible name, so a reader hears
 * "Rejected finding: ..." once rather than the mark a second time.
 */
export function RejectedPinMark({
  commentId,
  kind,
}: {
  commentId: string;
  kind: RejectedPinKind;
}) {
  const before = kind === "before";
  return (
    <span
      data-testid={
        before
          ? `ask-v2-review-pin-rejected-before-${commentId}`
          : `ask-v2-review-pin-rejected-${commentId}`
      }
      aria-hidden="true"
      className={cx(
        "absolute -right-1 -top-1 flex size-3.5 items-center justify-center rounded-full border border-puntt-neutral-gray-9 bg-base-white text-puntt-neutral-gray-11",
        before && "border-dashed",
      )}
    >
      {before ? (
        <ClockCounterClockwise size={8} weight="bold" />
      ) : (
        <X size={8} weight="bold" />
      )}
    </span>
  );
}
